import { Request } from '@/classes/Request.ts'

export const saveAutoPaymentSettings = async (
  districtId: TDistrictId,
  payload: Object
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/auto_payment_settings/save/${districtId}`, payload)
      .then(result => {
        resolve(result.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
